/**
 * Which categories an account may pick for a campaign: its allowed ones, plus the public catalog
 * for a live account. Unsorted - each page sorts by what it shows - but always a new array.
 *
 * A test only account may only run test only categories and a live account only live ones. The
 * backend enforces that (AccountHelpers.CheckTestCriteriaForAccountAndCategory) when an admin
 * approves the campaign and when it syncs to Ringba, not when it is created - a wrong pick is
 * accepted, then never goes live. The public catalog never returns test only categories, so it is
 * not merged in for a test only account. The account details carry no flag for that, so the
 * account is read off its allowed categories.
 *
 * @param {Array<object>} allowedCategories the account's own categories
 * @param {Array<object>} publicCategories the public catalog
 * @returns {Array<object>}
 */
export function getSelectableCategories(allowedCategories, publicCategories) {
  if (allowedCategories.some(category => category.testOnly)) {
    return [...allowedCategories]
  }

  // Merge without duplicates: the account's own entry is the one kept.
  const otherPublicCategories = publicCategories.filter(
    publicCategory => !allowedCategories.some(
      allowedCategory => allowedCategory.id === publicCategory.id
    )
  )

  return allowedCategories.concat(otherPublicCategories)
}
